import React, { Component } from 'react';
import { Modal, Spin, message, InputNumber } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

class SetCount extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    show = record => {
        this.setState({
            data: {...record},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { data: { count, visitTypeId } } = this.state;
        if(count !== 0 && !count){
            return message.warning("尚未设置次数!");
        }
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.setVisitCount,
            data: {
                count,
                visitTypeId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    render() {
        const { data, visible, loading } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title="设置次数"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">访视次数:</div>
                                <div className="item-right">{data.visitTypeName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">{asterisk}次数:</div>
                                <div className="item-right">
                                    <InputNumber
                                        min={1}
                                        precision={0}
                                        value={data.count}
                                        style={{width: 120}}
                                        onChange={value => this.handleChange(value, 'count')}
                                    />
                                    <span style={{marginLeft: 6}}>次</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default SetCount;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/SetCount.js